<template>
  <div class="flex student">
    <div class="basic">
      <student-profile :student="student" :edit_id="edit_id"></student-profile>
    </div>
    <div class="m-AddBox">
      <student-tutors-index :student="student"></student-tutors-index>
    </div>
    <div class="m-support">
      <student-history :student="student" :condition="condition" :edit_id="edit_id" type="true"></student-history>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    student: Object,
    condition: Object,
    edit_id: Object
  },
  data () {
    return {
    }
  },
  computed: {
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  beforeRouteLeave (to, from, next) {
    if (this.edit_id.student_id === this.student.id) {
      alert('生徒情報が編集中です')
      return
    } else if (this.condition.condition) {
      alert('対応履歴が編集中です')
      return
    } else if (this.edit_id.list_id) {
      alert('対応履歴が編集中です')
      return
    }
    next()
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss">
.flex {
  display: flex;
}
.student {
  &:after {
    content: "\f2bd";
    font-family: FontAwesome;
    position: absolute;
    font-size: 500px;
    top: 50%;
    left: 50%;
    margin-top: -250px;
    margin-left: -250px;
    color: #ddd;
    opacity: 0.1;
    z-index: -1;
  }
}
</style>



// WEBPACK FOOTER //
// StudentIndex.vue?1ceefbcd